/* ============================================================
   OXIFY — The Oxify Approach
   Shared by the split oxify-*-approach sections. Loads once per page.
   · champagne particle drift on any [data-particles] canvas
   · scroll reveal — items fade/rise in as they enter view
   Each element inits at most once; re-running boot() after a
   theme-editor section load is safe.
   ============================================================ */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initParticles(cv) {
    if (cv.dataset.oxInit) return;
    cv.dataset.oxInit = '1';
    var ctx = cv.getContext('2d'), w, h, dpr, ps = [], t = 0;
    function sp(any) {
      return { x: Math.random() * w, y: any ? Math.random() * h : h + 20, r: .6 + Math.random() * 2.4,
               s: .1 + Math.random() * .45, d: (Math.random() - .5) * .25, ph: Math.random() * 6.28,
               a: .1 + Math.random() * .45 };
    }
    function size() {
      dpr = Math.min(2, window.devicePixelRatio || 1);
      w = cv.clientWidth; h = cv.clientHeight;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(w * h / 30000 * 0.5);
      ps = Array.from({ length: n }, function () { return sp(true); });
    }
    function draw() {
      t += .006;
      ctx.clearRect(0, 0, w, h);
      ps.forEach(function (p, i) {
        if (!reduce) { p.y -= p.s; p.x += p.d + Math.sin(t * 1.4 + p.ph) * .15; }
        if (p.y < -10) ps[i] = sp(false);
        var a = p.a * (.6 + .4 * Math.sin(t * 2 + p.ph));
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 3.4);
        g.addColorStop(0, 'rgba(200,178,130,' + a + ')');
        g.addColorStop(.35, 'rgba(200,178,130,' + a * .35 + ')');
        g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 3.4, 0, 6.28); ctx.fill();
      });
      if (!reduce) requestAnimationFrame(draw);
    }
    size();
    window.addEventListener('resize', size);
    draw();
  }

  var revealIO = null;
  function initReveal() {
    var els = document.querySelectorAll('.oxap[data-reveal-scroll] [data-reveal]:not([data-ox-rev])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('.oxap[data-reveal-scroll]').forEach(function (s) { s.classList.add('js-reveal'); });

    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          var sibs = el.parentElement
            ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.hasAttribute('data-reveal'); })
            : [el];
          var i = Math.max(0, sibs.indexOf(el));
          el.style.transitionDelay = (i * 220) + 'ms';
          el.classList.add('is-in');
          revealIO.unobserve(el);
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -18% 0px' });
    }

    els.forEach(function (el) { el.setAttribute('data-ox-rev', '1'); revealIO.observe(el); });
  }

  function boot() {
    document.querySelectorAll('.oxap [data-particles] canvas').forEach(initParticles);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
